import { createAction, miniSerializeError } from "@reduxjs/toolkit"

export const hasError = createAction("HAS_ERROR", (e: Error) => {
    return {
        payload: miniSerializeError(e),
    }
})
export const clearError = createAction("CLEAR_ERROR")
